import styled from '@emotion/styled';
import { Button, IconButton, PopoverSurface, Typography, grey, navy, tokens } from '@galaxy-react/core';

export const StyledPopoverSurface = styled(PopoverSurface)({
  width: 'min(900px, 100%)',
  // minHeight: 200,
  backgroundColor: 'red',

  '&.fui-PopoverSurface': {
    background: tokens.colorNeutralBackground1,
  },
});

export const StyledSearchButton = styled(Button)({
  '&.fui-Button': {
    backgroundColor: navy[100],
    width: 'min(600px, 100%)',
    justifyContent: 'start',
    '&:hover': {
      backgroundColor: navy[100],
    },
    '&:active, &:focus-visible': {
      boxShadow: 'none',
    },
  },
});

export const StyledIconButton = styled(IconButton)({
  marginLeft: 'auto',
  '&.fui-Button': {
    width: 20,
    height: 20,
    '&:focus, &:active': {
      border: 'none',
      boxShadow: 'none',
    },
  },
});

export const Wrapper = styled('div')({
  flex: 1,
  padding: '0 24px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
});

export const AnchorElement = styled('div')({
  height: 0,
});

export const IconButtonStyled = styled(IconButton)({
  '&.fui-Button:hover': {
    background: 'transparent',
  },
  '&.fui-Button': {
    padding: tokens.spacingHorizontalNone,
    width: '16px',
    height: '16px',
    marginLeft: tokens.spacingVerticalL,
  },
});

export const LabelStyled = styled(Typography)({
  color: grey[600],
});

export const ContentAfterStyled = styled('div')({
  display: 'flex',
});
